<template>
	<div class="order_detail">
		<div class="card">
			<div class="title">订单详情</div>
			<div class="base">
				<div class="header">
					<div class="left">
						<div class="name">{{ title }}</div>
						<div class="status">
							状态：<span class="error">{{ status_name }}</span>
						</div>
						<!-- 订单类型 -->
						<div class="order_types_css">
							<Tag color="success" v-if="order_type == 2">一口价</Tag>
							<Tag color="warning" v-if="order_type == 1">报价招标</Tag>
						</div>
					</div>
					<!--4待上门 5 服务中 6-待验收；7-待评价； 8-已完成； 9-交易关闭；10-售后 11售后处理中 12师傅同意退款 13师傅拒绝 14 平台介入  15 平台驳回 16 平台退款-->
					<div class="right">
						<Button type="error" size="small" v-if="status == 5||status == 6 || status == 7"
							@click="$router.push({ name: 'order_refund', params: { id: id } })"
							style="margin-right: 10px">申请退款</Button>
						<Button type="success" size="small" v-if="status == 7"
							@click="$router.push({ name: 'order_evaluate', params: { id: id } })"
							style="margin-right: 10px">去评价</Button>
						<Button type="warning" size="small" v-if="status == 7"
							@click="$router.push({ name: 'order_complaint', params: { id: id } })"
							style="margin-right: 10px">投诉</Button>
						<Button type="primary" size="small" v-if="status == 6" @click="acceptance()">确认验收</Button>
						<Button type="primary" size="small" v-if="status == 3"
							@click="$router.push({ name: 'order_pay', params: { id: id } })">去支付</Button>
						<Button type="primary" size="small" v-if="status == 4||status == 5"
							@click="$router.push({ name: 'order_pay', params: { id: id, type: 'addMoney' } })">增加费用</Button>
						<Button class="cancel" size="small" v-if="status < 4" @click="changeOrder()">修改订单</Button>
						<Button class="cancel" size="small" v-if="status < 4" @click="cancel()">取消订单</Button>
						<Button class="cancel" size="small" v-if="status ==2&&order_type==1" @click="hireMaster">雇佣师傅</Button>
						<Button class="cancel" size="small" v-if="status > 14 || status == 9||status==8"
							@click="delOrder()">删除订单</Button>
						<Button class="cancel" size="small" v-if="status == 11" @click="cancelApply()">撤销申请</Button>
						<Button class="cancel" type="warning" size="small" v-if="status == 13" @click="intervene()">平台介入</Button>
					</div>
				</div>
				<div class="info">
					<span>客户：{{ nickname }}</span>
					<span>订单编号：{{ order_no }}</span>
					<span>下单时间：{{ created_at }}</span>
					<span v-if="end_date != ''">截止时间：{{ end_date }}</span>
					<span v-if="orderInfos.visit_time != ''">上门时间：{{ orderInfos.visit_time }}</span>
					<span v-if="orderInfos.complete_time != ''">完成时间：{{ orderInfos.complete_time }}</span>
				</div>
			</div>
		</div>
		<div class="block"></div>
		<el-tabs v-model="activwName">
			<el-tab-pane name="first">
				<span slot="label">订单信息</span>
				<div class="step">
					<div class="title">订单进度</div>
					<Steps :current="step">
						<Step title="待报价"></Step>
						<Step title="待雇佣"></Step>
						<Step title="待支付"></Step>
						<Step title="待上门"></Step>
						<Step title="服务中"></Step>
						<Step :title="order_status.is_checked == 0 && status >= 11 ? '售后中' : '待验收'"></Step>
						<Step :title="order_status.is_evaluated == 0 && status >= 11 ? '售后中' : '待评价'"></Step>
						<Step title="已完成" v-if="status < 11"></Step>
						<Step title="已退款" v-if="status == 12"></Step>
						<Step title="已拒绝" v-if="status >= 13"></Step>
						<Step title="平台处理" v-if="status == 14"></Step>
						<Step title="已驳回" v-if="status == 15"></Step>
						<Step title="已退款" v-if="status == 16"></Step>
					</Steps>
				</div>
				<div class="block"></div>
				<div class="user-info">
					<el-descriptions title="客户信息" :column="2">
						<el-descriptions-item label="客户姓名" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ address.name }} </el-descriptions-item>
						<el-descriptions-item label="手机号码" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ customerPhoneDisplay }}
							<Icon type="ios-browsers" @click="copyText(customerPhoneDisplay)" />
							 <!-- <span id="">复制</span> -->
							</el-descriptions-item>
						<el-descriptions-item label="客户地址" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ address.address }} </el-descriptions-item>
						<el-descriptions-item label="楼层信息" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ address.floor }} </el-descriptions-item>
						<el-descriptions-item label="是否核销" label-class-name="descriptions-label"
							content-class-name="descriptions-label" v-if="address.third != ''">{{ address.third }}
						</el-descriptions-item>
					</el-descriptions>
				</div>
				<div class="block" v-if="rejection_reason"></div>
				<div class="padding-sm" v-if="rejection_reason">
					<div class="text-lg margin-bottom-sm">平台驳回</div>
					<div class="margin-top-sm">驳回原因： {{ rejection_reason }}</div>
				</div>
				<div class="block" v-if="worker_reason.reason"></div>
				<div class="padding-sm" v-if="worker_reason.reason">
					<div class="text-lg margin-bottom-sm">师傅拒绝</div>
					<div class="demo-image__preview">
						<el-image style="width: 100px; height: 100px" class="margin-right-sm radius-4"
							v-for="(item, index) in worker_reason.img" :key="index" :src="item" :preview-src-list="worker_reason.img">
						</el-image>
					</div>
					<div class="margin-top-sm">拒绝说明： {{ worker_reason.reason }}</div>
				</div>
				<div class="block" v-if="return_info.refund_money"></div>
				<div class="padding-sm" v-if="return_info.refund_money">
					<div class="text-lg margin-bottom-sm">已退款</div>

					<div class="margin-top-sm">
						退款金额：<span class="text-red">{{ return_info.refund_money }}</span>
					</div>
					<div class="margin-top-sm">退款账户： {{ return_info.account||'原路返回' }}</div>
					<div class="margin-top-sm">
						退款时间：<span class="text-red">{{ return_info.refund_time }}</span>
					</div>
				</div>
				<div class="block" v-if="after_info.refund_money"></div>
				<div class="padding-sm" v-if="after_info.refund_money">
					<div class="text-lg margin-bottom-sm">售后描述</div>
					<div class="demo-image__preview">
						<el-image style="width: 100px; height: 100px" class="margin-right-sm radius-4"
							v-for="(item, index) in after_info.img" :key="index" :src="item" :preview-src-list="after_info.img">
						</el-image>
					</div>
					<div class="margin-top-sm">售后说明： {{ after_info.remark }}</div>
					<div class="margin-top-sm">
						退款金额：<span class="text-red">{{ after_info.refund_money }}</span>
					</div>
				</div>
				<div class="block" v-if="complete.srcList"></div>
				<div class="padding-sm" v-if="complete.srcList">
					<div class="text-lg margin-bottom-sm">完工图</div>
					<div class="demo-image__preview">
						<el-image style="width: 100px; height: 100px" class="margin-right-sm radius-4"
							v-for="(item, index) in complete.srcList" :key="index" :src="item" :preview-src-list="complete.srcList">
						</el-image>
					</div>
					<div class="margin-top-sm">备注：服务已完成，如果满意，请给好评哦，感谢！</div>
				</div>
				<div class="block" v-if="order_inscrease.length > 0"></div>
				<div class="padding-sm" v-if="order_inscrease.length > 0">
					<div class="text-lg margin-bottom-sm">增加费用信息</div>
					<div class="" v-for="(item, index) in order_inscrease" :key="index">
						<div class="margin-top-sm flex align-center justify-between">
							<div> 增加费用：<span class="text-red">{{ item.cost }}</span></div>
							<div class="flex align-center">
								<!-- status=1 已支付，0：未支付  is_refund=1，拒绝；0：未处理-->
								<Button type="primary" class="margin-right"
									@click="$router.push({ name: 'order_pay', params: { id: id,addid:item.id,type:'addMoney' ,money:item.cost,addReason:item.instruction} })"
									v-if="item.status==0&&item.is_refund==0">去支付</Button>
								<Button type="error" @click="refuseAddMoney(item)" v-if="item.status==0&&item.is_refund==0">拒绝</Button>
								<view class="text-green">{{item.status==1?'已支付':''}} </view>
								<view class="text-red" >{{item.is_refund==1?'已拒绝':''}} </view>
							</div>
						</div>
						<div class="margin-top-sm">备注： {{ item.instruction }}</div>
						<div class="margin-top-sm" v-if="item.is_refund==1">拒绝说明： {{ item.refund_reason }}</div>
					</div>
				</div>
				<div class="block"></div>
				<div class="user-info" v-if="logistics&&logistics.logistics_number">
					<el-descriptions title="物流信息" :column="2">
						<el-descriptions-item label="是否到货" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ logistics.arrive }} </el-descriptions-item>
						<el-descriptions-item label="物流单号" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ logistics.logistics_number }} </el-descriptions-item>
						<el-descriptions-item label="物流公司" v-if="logistics.company" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ logistics.company }} </el-descriptions-item>
						<el-descriptions-item label="提货地址" v-if="logistics.address" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ logistics.address }} </el-descriptions-item>
						<el-descriptions-item label="提货电话" v-if="logistics.phone" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ logistics.phone }} </el-descriptions-item>
						<el-descriptions-item label="包裹件数" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ logistics.package_number }}件 </el-descriptions-item>
						<el-descriptions-item label="代付运费" v-if="logistics.freight" label-class-name="descriptions-label"
							content-class-name="descriptions-label error">{{ logistics.freight }} </el-descriptions-item>
					</el-descriptions>
				</div>
				<div class="block"></div>
				<div class="user-info">
					<el-descriptions title="其他信息" :column="1">
						<el-descriptions-item label="时间要求" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ other.hope_complete }} </el-descriptions-item>
						<el-descriptions-item label="订单联系人" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ other.contact }} </el-descriptions-item>
						<el-descriptions-item label="优惠金额" label-class-name="descriptions-label" v-if="coupon_money>0"
							content-class-name="descriptions-label">{{ coupon_money }} </el-descriptions-item>
					</el-descriptions>
				</div>
				<div class="block"></div>
				<div class="step">
					<div class="title">商品信息</div>
					<Table class="product-info-table" :columns="columns" :data="data"></Table>
				</div>
				<div class="block"></div>
				<div class="user-info">
					<el-descriptions title="联系人信息" :column="2">
						<el-descriptions-item label="真实姓名" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ address.name }} </el-descriptions-item>
						<el-descriptions-item label="手机号码" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{ customerPhoneDisplay }} </el-descriptions-item>

					</el-descriptions>
				</div>
			</el-tab-pane>

			<el-tab-pane v-if="order_type == 2" name="second">
				<span slot="label">师傅信息</span>
				<div class="MasterList pd-10s">
					<MasterItem :nickname="worker.nickname" :head_img="worker.head_img" :worker_order="worker.order_number"
						:offer="worker.price" :phone="worker.phone" :id="id" :worker_id="worker_id" :order_id='id'
						:detail_worker_id="worker_id" :detail_status="status" :score="worker.score" v-if="worker.nickname">
					</MasterItem>
					<el-empty :image-size="120" v-if="!worker.nickname"></el-empty>
				</div>
			</el-tab-pane>

			<el-tab-pane v-if="order_type == 1" name="second">
				<span slot="label">{{status<3?'师傅报价':'师傅信息'}}（{{ offer_all }}）</span>
				<div class="MasterList pd-10s">
					<MasterItem :nickname="item.worker.nickname" :head_img="item.worker.head_img" :phone="item.worker.phone"
						:offer="item.offer" :tolls_time='item.tolls_time' :id="item.id" :message="item.message" @gotoPay="gotoPay"
						@assignSuccess="assignSuccess" :worker_id="item.worker_id" :detail_status="status" :order_id='id'
						:detail_worker_id="worker_id" :lastMonthNumber='item.lastMonthNumber'
						:cooperateNumber='item.cooperateNumber' :worker_order="item.worker_order"
						:score="item.score == null ? 0 : item.score" v-for="(item, i) in offer_data" :key="i"></MasterItem>
					<!-- <el-empty :image-size="120" v-if="offer_data.length==0"></el-empty> -->
					<!-- TODO 新增空状态组件 -->
					<EmptyTime :timeRun="end_time" v-if="offer_data.length <= 0 && !loading" />
				</div>
			</el-tab-pane>
		</el-tabs>
		<Modal title="图片预览" v-model="bigPicVisible">
			<img :src="bigPicUrl" v-if="bigPicVisible" style="width: 100%" />
		</Modal>
		<Modal title="商品视频" v-model="productVideoVisible" class-name="product-video-modal" footer-hide @on-visible-change="handleProductVideoVisibleChange">
			<video
				v-if="productVideoVisible && productVideoUrl"
				:src="productVideoUrl"
				controls
				autoplay
				preload="metadata"
				class="product-video-player">
			</video>
		</Modal>
		<Modal title="拒绝增加费用" v-model="refunceAdd" @on-ok="refuceChange" :loading="refuceLoading">
			<div class="bg-f8 padding-sm">
				<textarea class="bg-f8 w100" cols="30" rows="10" maxlength="50" placeholder="请输入备注说明" v-model="refunceContent"
					style="border: 0;"></textarea>
			</div>
		</Modal>
		<el-dialog title="修改手机号" :visible.sync="phoneModal" width="420px" custom-class="phone-edit-dialog">
			<el-form label-width="90px">
				<el-form-item label="手机号码">
					<div class="virtual-phone-row">
						<el-input
							class="virtual-phone-main"
							v-model="phoneForm.phone"
							maxlength="11"
							placeholder="请输入手机号"
							@input="phoneForm.phone = phoneForm.phone.replace(/\D/g, '').slice(0, 11)">
						</el-input>
						<el-input
							class="virtual-phone-suffix"
							v-model="phoneForm.virtual_phone_suffix"
							maxlength="8"
							placeholder="后缀">
						</el-input>
						<el-checkbox v-model="phoneForm.is_virtual_enabled">虚拟号</el-checkbox>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="phoneModal = false">取消</el-button>
				<el-button type="primary" :loading="phoneSaving" @click="savePhone">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import HeaderComponents from '../../../components/header'
import MasterItem from './components/master-item'
import cancelOrder from '../../../components/cancel-order'

export default {
  name: 'order_detail',
  components: {
    HeaderComponents,
    MasterItem
  },

  activated () {
    let vm = this
    vm.loading = true
    let id = this.$route.params.id
    vm.id = parseInt(id)
    vm.activwName = this.$route.params.activwName || 'first'
    this.getDetail()
  },
  data () {
    return {
      end_time: '',
      refunceAdd: false, // 拒绝增加费用
      loading: false, // 接口是否请求完毕
      step: 1,
      order_type: 1,
      order_status: '', // 验收 评价状态
      id: 0,
      worker_id: 0,
      offer_data: [],
      offer_all: 0,
      order_no: '',
      status_name: '',
      is_showImg: true,
      end_date: '',
      status: 0,
      activwName: 'first', // 点击订单切换
      nickname: '',
      title: '',
      created_at: '',
      worker: {
        head_img: '',
        nickname: '',
        phone: '',
        price: '',
        order_number: 0,
        score: 0
      },
      order_inscrease: [], // 增加费用
      after_info: {}, // 售后信息
      return_info: {}, // 退款信息
      worker_reason: {}, // 师傅拒绝
      rejection_reason: '', // 平台驳回原因
      complete: {
        srcList: []
      }, // 完工图
      coupon_money: '',
      logistics: {
        has: true,
        address: '',
        arrive: '',
        freight: '',
        logistics_number: '',
        package_number: '',
        phone: '',
        company: ''
      },
      other: {
        contact: '',
        hope_complete: ''
      },
      address: {
        name: '',
        address: '',
        floor: '',
        phone: '',
        is_virtual: '',
        virtual: '',
        virtual_phone_suffix: '',
        third: ''
      },
      refunceContent: '', // 拒绝说明
      addId: '', // 增加费用记录id
      refuceLoading: true, // 按钮加载中状态
      columns: [{
        title: '商品图片',
        key: 'name',
        render: (h, parms) => {
          console.log('h', h)
          console.log('parms', parms)
          let vm = this
          if (Array.isArray(parms.row.product_img) && parms.row.product_img.length > 0) {
            return h(
              'div',
              parms.row.product_img.map((item) => {
                return h('img', {
                  attrs: {
                    src: item,
                    style: 'width:40px;height:40px;margin-right:5px;object-fit: cover;'
                  },
                  on: {
                    click: () => {
                      this.showBigPic(item)
                    }
                  }
                })
              })
            )
          } else {
            return ''
          }
        }
      },
      {
        title: '商品视频',
        key: 'product_video',
        render: (h, parms) => {
          return this.renderProductVideo(h, parms.row.product_video)
        }
      },
      {
        title: '商品安装图',
        key: 'age',
        render: (h, parms) => {
          let vm = this
          if (Array.isArray(parms.row.install_img) && parms.row.install_img.length > 0) {
            return h(
              'div',
              parms.row.install_img.map((item) => {
                return h('img', {
                  attrs: {
                    src: item,
                    style: 'width:40px;height:40px;margin-right:5px'
                  },
                  on: {
                    click: () => {
                      this.showBigPic(item)
                    }
                  }
                })
              })
            )
          } else {
            return ''
          }
        }
      },
      {
        title: '环境图',
        key: 'age',
        render: (h, parms) => {
          let vm = this
          if (Array.isArray(parms.row.environment_img) && parms.row.environment_img.length > 0) {
            return h(
              'div',
              parms.row.environment_img.map((item) => {
                return h('img', {
                  attrs: {
                    src: item,
                    style: 'width:40px;height:40px;margin-right:5px'
                  },
                  on: {
                    click: () => {
                      this.showBigPic(item)
                    }
                  }
                })
              })
            )
          } else {
            return ''
          }
        }
      },
      {
        title: '商品类别/型号',
        render: (h, parms) => {
          return h(
            'div', {
              style: {
                // textAlign: 'center'
              }
            },
            [h('div', parms.row.product_model)]
          )
        }
      },
      {
        title: '商品数量',
        key: 'num'
      },
      {
        title: '特殊要求',
        key: 'special'
      }
      ],
      data: [],
      bigPicVisible: false,
      bigPicUrl: '',
      productVideoVisible: false,
      productVideoUrl: '',
      phoneModal: false,
      phoneLoading: false,
      phoneSaving: false,
      phoneForm: {
        name: '',
        phone: '',
        is_virtual_enabled: false,
        pro_city_dist: '',
        detailed_address: '',
        address: '',
        floor: '',
        is_elevator: '',
        number: 0,
        price: 0,
        latitude: '',
        longitude: '',
        is_virtual: '',
        virtual_phone_suffix: ''
      },
      orderInfos: ''
    }
  },
  computed: {
    customerPhoneDisplay () {
      const phone = this.address.phone || this.getVirtualPhone(this.address)
      const suffix = this.getVirtualPhoneSuffix(this.address)
      return [phone, suffix].filter(Boolean).join('-')
    }
  },
  methods: {
    renderProductVideo (h, productVideo) {
      const videoList = Array.isArray(productVideo) ? productVideo.filter(Boolean) : [productVideo].filter(Boolean)
      if (videoList.length <= 0) {
        return ''
      }
      return h('div', {
        class: 'product-video-list'
      }, videoList.map((videoUrl) => {
        return h('div', {
          class: 'product-video-thumb',
          attrs: {
            title: '点击播放'
          },
          on: {
            click: () => {
              this.showProductVideo(videoUrl)
            }
          }
        }, [
          h('video', {
            attrs: {
              src: videoUrl,
              preload: 'metadata',
              muted: true
            }
          }),
          h('span', {
            class: 'product-video-play'
          }, '▶')
        ])
      }))
    },
    showProductVideo (videoUrl) {
      this.productVideoUrl = videoUrl
      this.productVideoVisible = true
    },
    handleProductVideoVisibleChange (visible) {
      if (!visible) {
        this.productVideoUrl = ''
      }
    },
    // 复制
    copyText (val) {
      const textarea = document.createElement('textarea')
				      textarea.value = val
				      document.body.appendChild(textarea)
				      textarea.select()
				      document.execCommand('copy')
				      document.body.removeChild(textarea)
					  this.$message.success('已复制')
    },
    getPhoneFormFromDetail (data) {
      const address = data.address || {}
      const product = data.product || {}
      const virtualPhoneSuffix = this.getVirtualPhoneSuffix(address)
      return {
        name: address.name || '',
        phone: address.phone || this.getVirtualPhone(address) || '',
        pro_city_dist: address.pro_city_dist || address.city || '',
        detailed_address: address.detailed_address || address.address || '',
        address: address.address || [address.pro_city_dist || address.city || '', address.detailed_address || ''].filter(Boolean).join('-'),
        floor: address.floor === undefined || address.floor === null ? '' : String(address.floor),
        is_elevator: address.is_elevator === undefined || address.is_elevator === null ? (address.floor ? '0' : '1') : String(address.is_elevator),
        number: address.number || product.num || 0,
        price: address.price || product.reference || product.product_price || 0,
        latitude: address.latitude || '',
        longitude: address.longitude || '',
        is_virtual: this.getVirtualPhone(address) || address.phone || '',
        virtual_phone_suffix: virtualPhoneSuffix,
        is_virtual_enabled: !!virtualPhoneSuffix
      }
    },
    getVirtualPhone (address) {
      const value = String((address && address.is_virtual) || '')
      return /^1[3-9]\d{9}$/.test(value) ? value : ''
    },
    getVirtualPhoneSuffix (address) {
      if (!address) return ''
      return address.virtual || address.virtual_phone_suffix || address.phone_suffix || address.virtual_suffix || address.extension || ''
    },
    savePhone () {
      let vm = this
      const phone = String(vm.phoneForm.phone || '').trim()
      const virtualPhoneSuffix = vm.phoneForm.is_virtual_enabled ? String(vm.phoneForm.virtual_phone_suffix || '').trim() : ''
      if (!this.phoneForm.phone) {
        return this.$message.error('请输入手机号')
      }
      if (!/^1[3-9]\d{9}$/.test(this.phoneForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      this.phoneSaving = true
      this.$request('611cbabeb8a86', {
        name: vm.phoneForm.name,
        phone,
        pro_city_dist: vm.phoneForm.pro_city_dist,
        detailed_address: vm.phoneForm.detailed_address,
        address: vm.phoneForm.address || [vm.phoneForm.pro_city_dist, vm.phoneForm.detailed_address].filter(Boolean).join('-'),
        floor: String(vm.phoneForm.floor || ''),
        is_elevator: vm.phoneForm.is_elevator,
        number: vm.phoneForm.number,
        price: vm.phoneForm.price,
        latitude: vm.phoneForm.latitude,
        longitude: vm.phoneForm.longitude,
        is_virtual: vm.phoneForm.is_virtual_enabled ? phone : '',
        virtual: virtualPhoneSuffix,
        virtual_phone_suffix: virtualPhoneSuffix,
        order_no: vm.id || ''
      }).then(() => {
        vm.phoneModal = false
        vm.$message.success('修改成功')
        vm.getDetail()
      }).finally(() => {
        vm.phoneSaving = false
      })
    },
    refuseAddMoney (item) {
      this.refunceAdd = true
      this.addId = item.id
    },
    refuceChange () {
      if (!this.refunceContent) {
        this.$message({
          type: 'info',
          message: '请输入备注说明'
        })
        this.refuceLoading = false
        return
      }
      this.$request('6447a28056924', {
        order_id: this.id,
        id: this.addId,
        refund_reason: this.refunceContent
      }).then((res) => {
        if (res.data.code == 1) {
          this.refunceAdd = false
          this.getDetail()
          this.refunceContent = ''
        }
      })
    },
    // 修改订单
    changeOrder () {
      this.$router.push({
        name: 'place',
        query: {
          order_id: this.id
        }
      })
    },
    // 雇佣师傅
    hireMaster () {
      this.activwName = 'second'
    },
    // 获取商品信息
    getDetail () {
      let vm = this
      this.$request('6120ad9af2b9b', {
        order_id: this.id
      }).then((res) => {
        vm.loading = false
        vm.orderInfos = res.data.data
        vm.order_no = res.data.data.base.number
        vm.nickname = res.data.data.base.nickname
        vm.created_at = res.data.data.base.created_at
        vm.status_name = res.data.data.msg
        vm.status = res.data.data.status
        vm.order_status = res.data.data.order_status
        if (res.data.data.type_id == 12) {
          vm.columns[6].title = '故障描述'
        } else if (res.data.data.type_id == 5) {
          vm.columns = [{
            title: '商品图片',
            key: 'name',
            render: (h, parms) => {
              console.log('h', h)
              console.log('parms', parms)
              let vm = this
              if (Array.isArray(parms.row.product_img) && parms.row.product_img.length > 0) {
                return h(
                  'div',
                  parms.row.product_img.map((item) => {
                    return h('img', {
                      attrs: {
                        src: item,
                        style: 'width:40px;height:40px;margin-right:5px'
                      },
                      on: {
                        click: () => {
                          this.showBigPic(item)
                        }
                      }
                    })
                  })
                )
              } else {
                return ''
              }
            }
          },
          {
            title: '商品视频',
            key: 'product_video',
            render: (h, parms) => {
              return this.renderProductVideo(h, parms.row.product_video)
            }
          },
          {
            title: '保养类型',
            render: (h, parms) => {
              return h(
                'div', {
                  style: {
                    // textAlign: 'left'
                  }
                },
                [h('div', parms.row.product_maintain)]
              )
            }
          },
          {
            title: '商品数量',
            key: 'num'
          },
          {
            title: '保养要求',
            key: 'special'
          }
          ]
        } else {
          vm.columns[6].title = '特殊要求'
        }
        if (res.data.data.status == 10) {
          vm.step = 3
        } else if (res.data.data.status != 11) {
          vm.step = res.data.data.status - 1
        } else if (res.data.data.status == 11) {
          if (res.data.data.order_status.is_checked == 0) {
            // 未验收
            vm.step = 5
          } else if (res.data.data.order_status.is_checked == 1 && res.data.data.order_status.is_evaluated == 0) {
            // 已验收未评价
            vm.step = 6
          } else if (res.data.data.order_status.is_evaluated == 1) {
            // 已评价
            vm.step = 7
          }
        }

        vm.order_type = res.data.data.order_type
        vm.title = res.data.data.title

        if (res.data.data.end_date != '' && res.data.data.end_date != undefined && res.data.data.end_date !=
						null) {
          vm.end_date = res.data.data.end_date
        }
        vm.end_time = res.data.data.end_time

        vm.data = []
        if (res.data.data.product != '' && res.data.data.product != undefined) {
          vm.data.push(res.data.data.product)
        }

        vm.address.name = res.data.data.address.name
        vm.address.address = res.data.data.address.address
        vm.address.floor = res.data.data.address.floor
        vm.address.phone = res.data.data.address.phone
        vm.address.is_virtual = res.data.data.address.is_virtual || ''
        vm.address.virtual = res.data.data.address.virtual || ''
        vm.address.virtual_phone_suffix = res.data.data.address.virtual_phone_suffix || ''
        vm.address.third = res.data.data.third
        if (res.data.data.finished_img) {
          vm.complete.srcList = res.data.data.finished_img || []
        } else {
          vm.complete.srcList = ''
        }
        if (res.data.data.after_info) {
          vm.after_info = res.data.data.after_info
        } else {
          vm.after_info = {}
        }
        if (res.data.data.refund) {
          vm.return_info = res.data.data.refund
        } else {
          vm.return_info = {}
        }
        if (res.data.data.order_inscrease) {
          vm.order_inscrease = res.data.data.order_inscrease
        } else {
          vm.order_inscrease = []
        }

        if (res.data.data.worker_reason) {
          vm.worker_reason = res.data.data.worker_reason
        } else {
          vm.worker_reason = {}
        }
        vm.rejection_reason = res.data.data.rejection_reason || ''
        vm.other.contact = res.data.data.other.contact
        vm.other.hope_complete = res.data.data.other.hope_complete
        vm.coupon_money = res.data.data.coupon_money || ''
        if (res.data.data.logistics != null && res.data.data.logistics != undefined && res.data.data.logistics !=
						'') {
          vm.logistics.address = res.data.data.logistics.address
          vm.logistics.arrive = res.data.data.logistics.arrive
          vm.logistics.freight = res.data.data.logistics.freight
          vm.logistics.logistics_number = res.data.data.logistics.logistics_number
          vm.logistics.package_number = res.data.data.logistics.package_number
          vm.logistics.company = res.data.data.logistics.company
          vm.logistics.phone = res.data.data.logistics.phone
          vm.logistics.has = true
        } else {
          vm.logistics.has = false
        }

        if (res.data.data.worker != null && res.data.data.worker != undefined && res.data.data.worker != '') {
          vm.worker_id = res.data.data.worker.worker_id
          vm.worker = res.data.data.worker
        } else {
          vm.worker = {}
        }

        vm.offer_data = []
        if (vm.order_type == 1) {
          this.$request('612349bfeff78', {
            order_id: this.id,
            page: 1,
            size: 1000
          }).then((res) => {
            vm.offer_all = res.data.data.count
            vm.offer_data = res.data.data.list

            console.log(res)
          })
        }
      })
    },
    showBigPic (item) {
      this.bigPicVisible = true
      this.bigPicUrl = item
    },
    acceptance () {
      let vm = this
      this.$util.throttle(() => {
        this.$request('614a8b63980c2', {
          order_id: vm.id
        }).then((res) => {
          this.$Confirm({
            title: '验收提醒',
            showCancel: false,
            desc: '如果师傅已经完成服务，请将下方核销码告知师傅，确认验收',
            text: res.data.data.finished_code
          }).then((res) => {
            console.log(res)
          })
        })
      }, 2000, true)
    },
    cancel () {
      let vm = this
      this.$cancelOrder({
        id: vm.id
      }).then((res) => {
        console.log(res)
        if (res == 'confirm') {
          console.log('----')
          vm.$message.success('操作成功')
          location.reload()
        }
      })
    },
    // 删除订单
    delOrder () {
      let vm = this
      this.$confirm('此操作将删除此订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$request('614c4dbce8c6d', {
          order_id: vm.id
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          // this.$router.go(-1)
          this.$router.push({
            	name: 'order_list'
          })
        })
      }).catch((err) => {
        console.log(err, 'err')
        this.$message({
          type: 'info',
          message: '删除失败'
        })
      })
    },
    cancelApply () {
      let vm = this
      this.$confirm('确定要撤销申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$request('614c37dcc38b3', {
            order_id: vm.id
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '撤销成功!'
            })
            location.reload()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 平台介入
    intervene () {
      let vm = this
      this.$confirm('确定要平台介入吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$request('614c3994a332d', {
            order_id: vm.id
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '申请成功!'
            })
            location.reload()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    gotoPay () {
      console.log('gotoPay')
    },
    // 指派成功
    assignSuccess () {
      let vm = this
      this.getDetail()
      // this.$util.throttle(() => {
      //   this.$request('612349bfeff78', {
      //     order_id: vm.id,
      //     page: 1,
      //     size: 1000
      //   }).then((res) => {
      //     vm.offer_all = res.data.data.count
      //     vm.offer_data = res.data.data.list

      //     console.log(res)
      //   })
      // }, 2000, true)
    }
  }
}
</script>

<style lang="less">
	.order_detail {
		.ivu-steps-title {
			margin-top: 2px;
		}

		.card {
			background-color: #ffffff;
			padding: 20px;
			border-radius: 3px;

			.base {
				margin-top: 30px;
				border-radius: 3px;

				.header {
					display: flex;
					justify-content: space-between;

					.left {
						display: flex;
					}

					.status {
						margin-left: 30px;

						.error {
							color: red;
						}
					}

					.right .cancel {
						margin-left: 10px;
					}
				}

				.info {
					margin-top: 10px;

					span {
						margin-right: 40px;
					}
				}
			}

			.title {
				font-size: 18px;
				color: #333;
				font-weight: 450;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					bottom: -10px;
					left: 0;
					width: 70px;
					height: 3px;
					background-color: #fb9e2f;
				}
			}
		}

		.block {
			height: 10px;
			background-color: #f7f8fa;
		}

		.step {
			padding: 20px;

			.title {
				margin-bottom: 15px;
				color: rgb(51, 51, 51);
				font-size: 18px;
				margin-right: 12px;
			}
		}

		.user-info {
			padding: 20px;
		}

		.descriptions-label {
			color: #333333;
		}

		.el-descriptions__title {
			color: rgb(51, 51, 51);
			font-size: 18px;
			font-weight: normal;
		}

		.error {
			color: red;
		}

		.product-info-table {
			.ivu-table-cell {
				padding-top: 8px;
				padding-bottom: 8px;
			}

			img {
				vertical-align: middle;
			}
		}
	}

	.product-video-list {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.product-video-thumb {
		position: relative;
		width: 80px;
		height: 45px;
		cursor: pointer;
		overflow: hidden;
		background: #000;
	}

	.product-video-thumb video {
		width: 100%;
		height: 100%;
		display: block;
		object-fit: cover;
		pointer-events: none;
	}

	.product-video-play {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 26px;
		height: 26px;
		line-height: 26px;
		text-align: center;
		transform: translate(-50%, -50%);
		border-radius: 50%;
		color: #fff;
		background: rgba(0, 0, 0, 0.55);
		font-size: 13px;
	}

	.product-video-modal .ivu-modal {
		width: 720px !important;
		max-width: 90vw;
	}

	.product-video-player {
		width: 100%;
		max-height: 70vh;
		display: block;
		background: #000;
	}

	.pd-10s {
		padding: 10px;
	}

	.order_types_css {
		margin-left: 20px;
	}

	.virtual-phone-row {
		display: flex;
		align-items: center;
	}

	.virtual-phone-main {
		width: 190px;
	}

	.virtual-phone-suffix {
		width: 86px;
		margin-left: 10px;
	}

	.virtual-phone-row .el-checkbox {
		margin-left: 10px;
		white-space: nowrap;
	}
</style>
